import { TermsOfServicePage } from "@-/dev.improve.haniverse.routes.legal";

export default function TermsRoute() {
  return <TermsOfServicePage />;
}
